import React from 'react';
import PropTypes from 'prop-types';
import ASQSimpleSurveysHeader from './ASQSimpleSurveysHeader';
import ASQSimpleSurveysRow from './ASQSimpleSurveysRow';
import InfiniteScroll from 'react-infinite-scroller';
import { flatten, isEmpty } from 'lodash';
import { tableNoResults, tableSpinner } from '../helpers/TableHelpers';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { ANIMATIONS } from 'utils/Animations';

export default class ASQSimpleSurveysTable extends React.Component {
    static propTypes = {
      auth: PropTypes.object.isRequired,
      isLoading: PropTypes.bool.isRequired,
      isFetching: PropTypes.bool.isRequired,
      location: PropTypes.object.isRequired,
      meta: PropTypes.object.isRequired,
      onASQLink: PropTypes.func.isRequired,
      onSortChange: PropTypes.func.isRequired,
      playerId: PropTypes.number.isRequired,
      surveys: PropTypes.arrayOf(PropTypes.object).isRequired,
    }

    onLoadMore = () => {
      // For Infinite scroll, better not use it but for now...
    }

    shouldComponentUpdate(nextProps) {
      return !nextProps.isFetching;
    }

    render() {
      const {
        auth, isLoading, location, meta,
        playerId, surveys, onASQLink, onSortChange,
      } = this.props;
      if (surveys != null) {
        const rows = flatten(
          surveys.map(
            (s, i) =>
              <CSSTransition key={`${s.id}-${i}`} timeout={{ enter: ANIMATIONS.in, exit: 0 }} classNames='a-fade'>
                <ASQSimpleSurveysRow playerId={playerId} auth={auth} questionnaire={s} playerIdx={i}
                  onASQLink={onASQLink} location={location} />
              </CSSTransition>
          )
        );

        return (
          <div className='o-rtable o-rtable--bordered u-margin-bottom--gutter2x'>
            <ASQSimpleSurveysHeader auth={auth} meta={meta} onSortChange={onSortChange} />
            { (isEmpty(surveys) ) ? tableNoResults() :
              isLoading ? tableSpinner() :
                <InfiniteScroll
                  pageStart={0}
                  loadMore={this.onLoadMore}
                  hasMore={ false }
                  loader={tableSpinner()}
                  initialLoad={false}
                  useWindow={true}>
                  <TransitionGroup exit={false}>
                    { rows }
                  </TransitionGroup>
                </InfiniteScroll>
            }
          </div>
        );
      } else {
        return tableNoResults()
      }
    }
}
